import React from 'react';
import { View, ViewStyle } from 'react-native';
import { getSteps, TOUR_TYPES } from '../../store/useTourStore';
import { useTranslation } from 'react-i18next';

type Props = {
  type?: TOUR_TYPES;
  order: number;
  style?:any;
  children: React.ReactNode;
};


export default function TourStep({
  type = TOUR_TYPES.ONBOARDING,
  order,
  style,
  children,
}: Props) {
  const { t } = useTranslation();
  const step = getSteps(t, type)[order - 1]
  return <View style={style} id={step.target}>{children}</View>;

}
